export const HAGEBAU_ORG_ID = 'HAGEBAU SK OBJEKT';
export const PRUEM_ZLWESEREMS_ORG_ID = 'ZLWESEREMS';
export const GARANT_G999_ORG_ID = 'G999';

export const HAGEBAU_ORG_IDS_LIST = [HAGEBAU_ORG_ID, PRUEM_ZLWESEREMS_ORG_ID, GARANT_G999_ORG_ID];
